import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionOptionIsNextMorning } from "./is-next-mornig/is-next-morning";

import type { StandardOptionCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	optionAttributes: StandardOptionCategoriesAndManagerStore["optionAttributes"];
};

export const QuestionOptionAttributes = ({ optionAttributes }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper islandTitle="特殊なオプション属性" categoryStore={optionAttributes}>
			<QuestionOptionIsNextMorning />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionOptionAttributes.displayName = "QuestionOptionAttributes";
